import {Component} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FilterOperator} from '@progress/kendo-data-query';
import {BaseGridFilterComponent, pickFilterOperators} from '@q9elements/ui-kit/components';

@Component({
  selector: 'app-code-search-numeric-filter',
  template: `
    <ng-container [formGroup]="filterForm">
      <q9-grid-filter-operator-select
        formControlName="operator"
        [operators]="operators"></q9-grid-filter-operator-select>

      <mat-form-field>
        <input type="number" matInput formControlName="value" />
      </mat-form-field>
    </ng-container>
  `
})
export class CodeSearchNumericFilterComponent extends BaseGridFilterComponent {
  operators = pickFilterOperators([
    FilterOperator.EqualTo,
    FilterOperator.NotEqualTo,
    FilterOperator.GreaterThan,
    FilterOperator.LessThan,
    FilterOperator.GreaterThanOrEqual,
    FilterOperator.LessThanOrEqual
  ]);
  filterForm = new FormGroup({
    operator: new FormControl(FilterOperator.EqualTo),
    value: new FormControl(null, {
      updateOn: this.popupService ? 'change' : 'blur'
    })
  });
}
